import { Add, AddCircle, Delete, Edit } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton, Tooltip } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { CustomDescrypt } from 'global/func';
import { getDataWithResponse } from 'global/getFunc';
import { MaterialReactTable } from 'material-react-table';
import React, { useEffect, useState } from 'react'
import userStore from 'store/userStore';
import EditData from './EditData';
import TambahUser from './TambahUser';
import ArgonButton from 'components/ArgonButton';
import Swal from 'sweetalert2';
import { postDelete } from 'global/postFunc';
// import EditData from './EditData';

const AdminOpd = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [updating, setUpdating] = useState(false)

    const [editData, setEditData] = useState({})

    const reqAdminOpd = () => {
        setLoading(true)
        addReq()
        getDataWithResponse(
            '/sa/users/admin-opd',
            decryptedUser,
            (res) => {
                setLoading(false)
                console.log(res);
                setData(res)
            },
            (res) => {
                setLoading(false)
                console.log(res)
            }

        )
    }

    useEffect(() => {
        reqAdminOpd()
        console.log(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updating])

    const [openEdit, setOpenEdit] = useState(false);
    const [openTambah, setOpenTambah] = useState(false);
    // const handleOpen = (params) => {
    //     setOpen(true)
    //     setEditData(params)
    //     console.log(params);
    // };
    const handleCloseEdit = () => setOpenEdit(false);
    const handleCloseTambah = () => setOpenTambah(false);

    const columns = [
        {
            accessorKey: 'opd',
            header: 'OPD',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.row.original.pd.kd_pd}
                    </ArgonTypography>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.row.original.pd.nama_pd}
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'nama',
            header: 'Nama Admin',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.row.original.nip || '-'}
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'username',
            header: 'Username',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'password',
            header: 'Password',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.getValue()}
                    </ArgonTypography>
                </>
            )
        },
    ];

    const deleteUser = (username) => {
            Swal.fire({
                title: `Hapus Data?`,
                text: `User ${username} akan Dihapus`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Hapus',
                cancelButtonText: 'Batal',
                confirmButtonColor: '#dd3333',
                // cancelButtonColor: '#d33',
            }).then((result) => {
                if (result.isConfirmed) {
                    addReq()
                    postDelete(
                        '/sa/users/admin-opd-delete',
                        {
                            _method: 'DELETE',
                            username: username
                        },
                        decryptedUser,
                        setLoading,
                        () => { setUpdating(!updating) }
                    )
                }
            })
        }

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Admin OPD</ArgonTypography>
                        }
                        action={
                            <Tooltip title="Tambah">
                                <ArgonButton
                                    variant='contained'
                                    color="primary"
                                    size="small"
                                    startIcon={<AddCircle />}
                                    onClick={() => setOpenTambah(true)}
                                >
                                    Tambah
                                </ArgonButton>
                            </Tooltip>
                        }
                    />
                    <CardContent>
                        <MaterialReactTable
                            columns={columns}
                            data={data}
                            // enableExpanding
                            // enableExpandAll
                            muiTableHeadCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTableFooterCellProps={{
                                sx: {
                                    fontSize: '0.875rem !important',
                                    color: 'text.main !important'
                                }
                            }}
                            muiTopToolbarProps={{
                                sx: { fontSize: '0.875rem' }
                            }}
                            initialState={{
                                expanded: true
                            }}
                            enablePagination={false}
                            enableColumnFilters={false}
                            enableSorting={true}
                            state={{ isLoading: loading }}
                            enableRowActions={true}
                            positionActionsColumn='first'
                            displayColumnDefOptions={{
                                'mrt-row-actions': {
                                    header: 'Action', //change header text
                                    size: 20, //make actions column wider
                                    alignment: 'center'
                                }
                            }}
                            renderRowActions={({ row }) => [
                                <Tooltip title="Edit">
                                    <IconButton aria-label="edit" 
                                    onClick={() => {
                                        setOpenEdit(true)
                                        setEditData(row.original)
                                        console.log(row.eriginal);
                                    }} 
                                    color="success">
                                        <Edit color='success' />
                                    </IconButton>
                                </Tooltip>,
                                <Tooltip title="Hapus">
                                    <IconButton aria-label="edit" 
                                    onClick={() => {
                                        deleteUser(row.original.username)
                                        // console.log('edit');
                                    }} 
                                    color="success">
                                        <Delete color='error' />
                                    </IconButton>
                                </Tooltip>
                            ]}
                            enableRowNumbers
                            rowNumberDisplayMode='static'
                        />
                    </CardContent>
                </Card>
            </ArgonBox>
            <EditData
                data={editData}
                open={openEdit}
                handleClose={handleCloseEdit}
                addReq={addReq}
                decryptedUser={decryptedUser}
                updating={updating}
                setUpdating={setUpdating}
            />

            <TambahUser
                open={openTambah}
                handleClose={handleCloseTambah}
                addReq={addReq}
                decryptedUser={decryptedUser}
                updating={updating}
                setUpdating={setUpdating}
            />
        </ArgonBox>
    )
}

export default AdminOpd